export default __webpack_public_path__ + "90a77d6d5695fc15af865ccbe5d91c22.svg";